import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbToggle from "../ui-kit/dfb_toggle"

const CCardToggle = props => {
  const icon = props.class ? props.class.replace(/^dfb-icon-/, "") : "favourite"
  const title = props.title

  return (
    <div
      className={`
      c-CardToggle
      ${props.checked ? "c-CardToggle--checked" : ""}
      ${props.disabled ? "c-CardToggle--disabled" : ""}
      dfb-Card
    `}
      onClick={props.onClick}
    >
      <DfbIcon icon_type={icon} add_class="c-CardToggle-icon" />
      <DfbHeadline
        headline={title}
        headline_level="h6"
        add_class="c-CardToggle-headline"
      />
      <DfbToggle
        name={props.uid}
        disabled={props.disabled}
        checked={props.checked}
        labelChecked=""
        labelUnchecked=""
        ariaLabel={title}
        onChange={props.onChange}
      />
    </div>
  )
}

export default CCardToggle
